// extracted by mini-css-extract-plugin
module.exports = {"content":"dCn9y","tags":"EzekK","line":"BhyCR","disclaimer":"lNwkm"};